export default { sha: '1df231d48761faa12221746ebc178588169b4bdc', buildNumber: 'undefined' }
